export enum UnitType {
	Metric = 1,
	Imperial = 2
}